// Import the react JS packages
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "@mui/material/Input";
import Button from "@mui/material/Button";
import { useAuth } from "../context/AuthContext";

// Module-level variable to persist error across component re-mounts
let persistentLoginError = "";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState(persistentLoginError);
  const { login } = useAuth();
  const navigate = useNavigate();


  // Sync with persistent error on mount
  useEffect(() => {
    if (persistentLoginError && !loginError) {
      setLoginError(persistentLoginError);
    }
  }, []);

  useEffect(() => {
    persistentLoginError = loginError;
  }, [loginError]);

  const submit = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setLoginError(""); // Clear any previous error
    
    const user = {
      username: username.trim(),
      password: password,
    };

    try {
      const result = await login(user);

      if (!result.success) {
        throw new Error(result.errorMessage || "Login failed");
      }

      // Success! Navigate to AdvanceTender page
      persistentLoginError = "";
      localStorage.setItem("user", result.data.username);
      navigate("/AdvanceTender");
      
    } catch (error) {
      // Use the specific error message if available
      const errorMessage = error.message || "Login failed. Please check your credentials.";
      console.error("Login error:", errorMessage);
      
      // Store in module variable to persist across component re-mounts
      persistentLoginError = errorMessage;
      setLoginError(errorMessage);
      
      setPassword("");
      // Don't clear username on error so user doesn't have to retype it
    }
  };

  // Clear error when user starts typing
  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  return (
    <div className="Auth-form-container">
      <div className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Sign In</h3>
          {loginError && (
            <div style={{ color: 'red', marginBottom: '16px' }}>
              {loginError}
            </div>
          )}
          <div className="form-group mt-3">
            {/* <label>Username  </label> */}
            <Input
              className="form-control mt-1"
              placeholder="Enter Username"
              name="username"
              type="text"
              value={username}
              required
              onChange={handleUsernameChange}
            />
          </div>
          <div className="form-group mt-3">
            {/* <label>Password  </label> */}
            <Input
              name="password"
              type="password"
              className="form-control mt-1"
              placeholder="Enter Password"
              value={password}
              required
              onChange={handlePasswordChange}
            />
          </div>
          <div className="d-grid gap-2 mt-3">
            <Button type="button" className="btn btn-primary" onClick={submit}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
